import { Modal } from "@general-backoffice/core";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "reactstrap";

import ambassador1 from "../../../media/legal/ambassador1.png";
import ambassador2 from "../../../media/legal/ambassador2.png";

interface TnCModalProps {
  isOpen: boolean;
  close: () => void;
  acceptTerms: () => void;
  tnCText?: string;
}

const TnCModal = ({ isOpen, close, acceptTerms, tnCText = "tycPartner" }: TnCModalProps) => {
  const { t } = useTranslation("referrer", { keyPrefix: "partner.tnCModal" });
  const { t: tLegal } = useTranslation("legal");

  return (
    <Modal.Simple
      isOpen={isOpen}
      closeIcon={false}
      toggleOpen={close}
      size="lg"
      title={t("title")}
      closeText={t("closeButton")}
    >
      <div className="my--3">
        <Trans
          t={tLegal}
          i18nKey={tnCText}
          components={{
            br: <br />,
            h1: <h1 />,
            h2: <h2 />,
            h3: <h3 />,
            ol: <ol />,
            ul: <ul />,
            li: <li />,
            ol_type_a: <ol type="a" />,
            ol_type_A: <ol type="A" />,
            ol_type_I: <ol type="I" />,
            small: <small />,
            img1: <img src={ambassador1} alt="" style={{ maxWidth: "100%" }} />,
            img2: <img src={ambassador2} alt="" style={{ maxWidth: "100%" }} />,
          }}
        />
        <div className="flex-center py-5">
          <Button type="button" color="success" size="lg" className="px-5" onClick={acceptTerms}>
            {t("acceptButton")}
          </Button>
        </div>
      </div>
    </Modal.Simple>
  );
};

export default TnCModal;
